import { useGetCompanies } from '@services/companies'
import { momentToString } from '@shared/innmaxLib/utils/webHelper'
import React from 'react'
import { IOcppTag, IOcppTagRes } from './ocpp.type'

export const useOcppTagConverter = () => {
  const { toFullPathName } = useGetCompanies()
  return React.useCallback(
    (data?: IOcppTagRes | null): IOcppTag | null => {
      return data
        ? {
            ...data,
            ownerName: toFullPathName(data.ownerSeq) || '-',
            expireAtStr: data.expireAt ? momentToString(data.expireAt) : '-',
          }
        : null
    },
    [toFullPathName]
  )
}
